<ol class="ProgressBar">
  <li *ngFor="let step of steps" class="ProgressBar-step {{ step.status }}"[ngClass]="{'clickable': step.isClickable === true}" title="{{ step.description }}" (click)="step.isClickable && onClick(step)">
    <svg class="ProgressBar-icon"><use xlink:href="#checkmark-bold"/></svg>
  </li>
</ol>
